module.exports = __webpack_public_path__ + "img/img1.aadfe47f.svg";